var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_850_3304)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 58,
    fill: "url(#paint0_radial_850_3304)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 91.8815C92.2107 91.8815 109 82.9537 109 71.9407C109 60.9278 92.2107 52 71.5 52C50.7893 52 34 60.9278 34 71.9407C34 82.9537 50.7893 91.8815 71.5 91.8815Z",
    fill: "url(#paint1_radial_850_3304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 90.4C91.4017 90.4 107.535 82.1355 107.535 71.9407C107.535 61.7459 91.4017 53.4814 71.5 53.4814C51.5983 53.4814 35.4648 61.7459 35.4648 71.9407C35.4648 82.1355 51.5983 90.4 71.5 90.4Z",
    fill: "#6181B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7949 77.926L80.582 68.6222C80.9922 66.5185 80.6406 64.9482 79.5859 63.9704C78.5606 63.0223 76.8027 62.5482 74.2246 62.5482H71.1191L71.9981 57.926C72.0273 57.7482 71.9981 57.5704 71.8809 57.4223C71.7637 57.2741 71.6172 57.2148 71.4414 57.2148H67.1641C66.8711 57.2148 66.6367 57.4223 66.5781 57.6889L64.6738 67.5556C64.4981 66.4297 64.0879 65.4815 63.3848 64.7111C62.125 63.2593 60.1621 62.5185 57.4961 62.5185H49.2637C48.9707 62.5185 48.7363 62.726 48.6777 62.9926L44.8399 83.0222C44.8106 83.2 44.8399 83.3778 44.957 83.526C45.0742 83.6741 45.2207 83.7334 45.3965 83.7334H49.7031C49.9961 83.7334 50.2305 83.5259 50.2891 83.2593L51.2266 78.4297H54.4199C56.0898 78.4297 57.5254 78.2519 58.6094 77.8963C59.752 77.5111 60.7773 76.8889 61.6856 76.0297C62.418 75.3482 63.0332 74.5778 63.502 73.7482L62.7402 77.7482C62.7109 77.926 62.7402 78.1037 62.8574 78.2519C62.9746 78.4 63.1211 78.4593 63.2969 78.4593H67.5742C67.8672 78.4593 68.1016 78.2519 68.1602 77.9852L70.2695 67.0222H73.1992C74.459 67.0222 74.8105 67.2593 74.9277 67.3778C75.0156 67.4667 75.1914 67.8222 74.9863 68.9185L73.2871 77.7778C73.2578 77.9556 73.2871 78.1334 73.4043 78.2815C73.5215 78.4297 73.668 78.4889 73.8438 78.4889H78.2383C78.502 78.4 78.7363 78.1926 78.7949 77.926ZM58.9902 70.2222C58.7266 71.6148 58.2285 72.6222 57.4961 73.1852C56.7637 73.7482 55.5625 74.0445 53.9805 74.0445H52.0762L53.4531 66.8741H55.9141C57.7305 66.8741 58.4629 67.2593 58.7559 67.5852C59.1367 68.0593 59.2246 68.9778 58.9902 70.2222Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0762 64.7111C95.8164 63.2593 93.8535 62.5186 91.1875 62.5186H82.8965C82.6035 62.5186 82.3691 62.726 82.3106 62.9926L78.4727 82.9926C78.4434 83.1704 78.4727 83.3482 78.5898 83.4963C78.707 83.6445 78.8535 83.7037 79.0293 83.7037H83.3359C83.6289 83.7037 83.8633 83.4963 83.9219 83.2297L84.8594 78.4H88.0527C89.7227 78.4 91.1582 78.2223 92.2422 77.8667C93.3848 77.4815 94.4102 76.8593 95.3184 76C96.0801 75.2889 96.7246 74.4889 97.1934 73.6297C97.6621 72.7704 98.0137 71.8223 98.2187 70.7852C98.7168 68.2074 98.3359 66.1926 97.0762 64.7111ZM92.5938 70.2223C92.3301 71.6149 91.832 72.6223 91.0996 73.1852C90.3672 73.7482 89.166 74.0445 87.584 74.0445H85.6797L87.0566 66.8741H89.5176C91.334 66.8741 92.0664 67.2593 92.3594 67.5852C92.7695 68.0593 92.8574 68.9778 92.5938 70.2223Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9141 66.2817C57.5547 66.2817 58.6387 66.578 59.1953 67.2002C59.752 67.8224 59.8691 68.8595 59.5762 70.341C59.2832 71.8817 58.6973 73.0076 57.8477 73.6595C56.998 74.3113 55.709 74.6373 53.9805 74.6373H51.373L52.9844 66.2817H55.9141ZM45.4258 83.1113H49.7324L50.7578 77.8076H54.4492C56.0898 77.8076 57.4082 77.6298 58.4629 77.2743C59.5176 76.9187 60.4551 76.3558 61.334 75.5261C62.0664 74.8447 62.6523 74.1039 63.0918 73.3039C63.5312 72.5039 63.8535 71.615 64.0293 70.6373C64.498 68.2669 64.1465 66.4298 63.0039 65.0965C61.8613 63.7632 60.0449 63.1113 57.5547 63.1113H49.2637L45.4258 83.1113Z",
    fill: "#000004"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1934 57.8076H71.4707L70.4453 63.1113H74.2539C76.6562 63.1113 78.2969 63.5261 79.2051 64.3854C80.1133 65.2447 80.377 66.6076 80.0254 68.5039L78.2383 77.8076H73.9023L75.6016 68.9484C75.8066 67.941 75.7187 67.2595 75.3965 66.9039C75.0742 66.5484 74.3418 66.341 73.2578 66.341H69.8301L67.6328 77.8076H63.3555L67.1934 57.8076Z",
    fill: "#000004"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5176 66.2817C91.1582 66.2817 92.2422 66.578 92.7988 67.2002C93.3555 67.8224 93.4727 68.8595 93.1797 70.341C92.8867 71.8817 92.3008 73.0076 91.4512 73.6595C90.6016 74.3113 89.3125 74.6373 87.584 74.6373H84.9766L86.5879 66.2817H89.5176ZM79.0293 83.1113H83.3359L84.3613 77.8076H88.0527C89.6934 77.8076 91.0117 77.6298 92.0664 77.2743C93.1211 76.9187 94.0586 76.3558 94.9375 75.5261C95.6699 74.8447 96.2559 74.1039 96.6953 73.3039C97.1348 72.5039 97.457 71.615 97.6328 70.6373C98.1016 68.2669 97.75 66.4298 96.6074 65.0965C95.4648 63.7632 93.6484 63.1113 91.1582 63.1113H82.8672L79.0293 83.1113Z",
    fill: "#000004"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_850_3304",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_850_3304"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_850_3304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72 72) rotate(85.4261) scale(54.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6181B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6181B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_850_3304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5152 59.0127) scale(49.2466 49.806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4C6B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.ea045f34b5eaccdacff9a4ea9d6e96f4.svg";
export { ForwardRef as ReactComponent };